module.exports = __webpack_public_path__ + "static/media/chevron-left.79d05ce9.svg";